/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {getRoutePageComponent, getContextRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {EmailTranslationResource} from '../../../components/api/resources/resource/email-translation.resource';


export function emailTranslationStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('email-translations.email-translation', EmailTranslationResource, 'app.adm', 'app/admin');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('email-translation-route') }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('email-translation-edit', 'edit')),
            views: {
            'content@app': {
              component: AdminResourceItemRoutePageComponent,
              bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }
            },
            'context@app': { component: AdminResourceContextRoutePageComponent }
          }
        }, 'EmailTranslation'));
  }, adnRouterHelper);
}
